import React, { useMemo, useRef } from "react";
import { useState, useEffect } from "react";
import {
  Button,
  Input,
  Modal,
  SelectNew,
  ConfirmDialog,
  FlashMessage,
  ReadMoreLess,
} from "../../../components/common";
import { useForm } from "react-hook-form";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import API_URLS from "../../../utils/apiUrls";
import httpRequest from "../../../utils/httpRequest";
import { deleteFeedRequest } from "../../../reducers/feeds/feedPost.reducer";
import { rootReducersState } from "../../../reducers";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { MoreHoriz } from "@material-ui/icons";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Menu, MenuItem } from "@material-ui/core";
import Image from "../../../components/common/Image";
import EditScheduledPostModal from "./EditSchduleModal";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { ReactComponent as PrevArrow } from "../../../assets/svg/angle-left-pink.svg";
import { ReactComponent as NextArrow } from "../../../assets/svg/angle-right-pink.svg";

dayjs.extend(utc);
dayjs.extend(timezone);

interface TimeOption {
  label: string;
  value: string;
}

interface PostMedia {
  id: string;
  media_thumbnail: string;
  media_type: string;
  media_original: string;
}
interface MyDataType {
  id: string;
  content?: string;
  schedule_at?: string;
  timezone?: string;
  post_media: PostMedia[];
}

interface ShareModelProps {
  open: boolean;
  onClose: () => void;
  profile?: any;
  setSchedule: (data: string | null) => void;
  scheduleValue?: string | null;
}

function ScheduleModel({
  open,
  onClose,
  profile,
  setSchedule,
  scheduleValue,
}: ShareModelProps) {
  const [time, setTime] = useState<TimeOption[]>([]);
  const [selectedTime, setSelectedTime] = useState<TimeOption>({
    label: "",
    value: "",
  });
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [showScheduleList, setShowScheduleList] = useState<boolean>(false);
  const [fetchedData, setFetchedData] = useState<MyDataType[] | null>(null);
  const [openDeleteFeedModal, setOpenDeleteFeedModal] =
    useState<boolean>(false);
  const [dateError, setDateError] = useState<string>("");
  const [timeError, setTimeError] = useState<string>("");
  const [carouselIndices, setCarouselIndices] = useState<Record<string, number>>(
    {}
  );
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [menuPostId, setMenuPostId] = useState<string | null>(null);
  const currentDate = new Date();
  const [editPost, setEditPost] = useState<MyDataType | null>(null);
  const [isRescheduling, setIsRescheduling] = useState<boolean>(false);
  const [reschedulePostId, setReschedulePostId] = useState<string | null>(null);
   const [userTimezone, setUserTimezone] = useState<string>("");
  
    useEffect(() => {
      setUserTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }, []);

  const maxDate = new Date(currentDate);
  maxDate.setMonth(currentDate.getMonth() + 1);
  
  // Rolling one-month window
  const monthStart = useMemo(() => dayjs().startOf("day"), []);
  const monthEnd = useMemo(() => dayjs().add(1, "month").endOf("day"), []);

  const [showCalendar, setShowCalendar] = useState(false);
  const calWrapRef = useRef<HTMLDivElement | null>(null);

  // Close popup when clicking outside
  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (!calWrapRef.current) return;
      if (!calWrapRef.current.contains(e.target as Node))
        setShowCalendar(false);
    }
    if (showCalendar) document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [showCalendar]);

  if (maxDate.getDate() !== currentDate.getDate()) {
    maxDate.setDate(0);
  }

  // handlers
  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>, id: string) => {
    setAnchorEl(e.currentTarget);
    setMenuPostId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPostId(null);
  };

  const handlePostNow = async () => {
    if (!menuPostId) return;
    const response = await httpRequest().post(API_URLS.postNow(menuPostId));
    if (response.status === 200) {
      setShowScheduleList(false);
      setAnchorEl(null);
      onClose();
      window.location.reload();
      FlashMessage("Post has been published now.", "success");
    } else {
      FlashMessage("Failed to publish post now.", "error");
    }
    handleMenuClose();
  };
  const handleReschedule = (post: MyDataType) => {
    setShowScheduleList(false);
    handleMenuClose();
    setIsRescheduling(true);
    setReschedulePostId(post.id);
    // prefill date and time
    const dt = dayjs.utc(post.schedule_at).local();
    setSelectedDate(dt.toDate());
    const tp = dt.format("HH:mm");
    setSelectedTime({ label: dt.format("hh:mm A"), value: tp });
  };

  const handleDelete = () => {
    setOpenDeleteFeedModal(true);
    handleMenuClose();
    setMenuPostId(menuPostId);
  };

useEffect(() => {
  if (open && !isRescheduling) {
    setSelectedDate(new Date());
  }
}, [open, isRescheduling]);

  // useEffect(() => {
  //   let currentTime = moment();
  //   const minutes = currentTime.minutes();
  //   const roundedMinutes = minutes <= 30 ? 30 : 60;
  //   const startTime = moment(currentTime)
  //     .minutes(0)
  //     .seconds(0)
  //     .add(roundedMinutes, "minutes");

  //   const endTime = moment().set({ hour: 23, minute: 30 });
  //   const timeOptions: TimeOption[] = [];

  //   while (startTime.isSameOrBefore(endTime)) {
  //     timeOptions.push({
  //       label: startTime.format("hh:mm A"),
  //       value: startTime.format("YYYY-MM-DD HH:mm"),
  //     });
  //     startTime.add(30, "minutes");
  //   }

  //   setTime(timeOptions);
  // }, []);

useEffect(() => {
  if (!selectedDate) return;

  let startTime: moment.Moment;
  const isToday = moment(selectedDate).isSame(moment(), "day");

  if (isToday) {
    // Start from next available half-hour slot
    const currentTime = moment();
    const minutes = currentTime.minutes();
    const roundedMinutes = minutes <= 30 ? 30 : 60;
    startTime = moment(currentTime)
      .minutes(0)
      .seconds(0)
      .add(roundedMinutes, "minutes");
  } else {
    // Start from midnight for future dates
    startTime = moment(selectedDate).startOf("day").add(0, "minutes");
  }

  const endTime = moment(selectedDate).set({ hour: 23, minute: 30 });
  const timeOptions: TimeOption[] = [];

  while (startTime.isSameOrBefore(endTime)) {
    timeOptions.push({
      label: startTime.format("hh:mm A"),
      value: startTime.format("YYYY-MM-DD HH:mm"),
    });
    startTime.add(30, "minutes");
  }

  setTime(timeOptions);

  // Auto-select first slot
  if (timeOptions.length > 0) {
    setSelectedTime({
      label: timeOptions[0].label,
      value: timeOptions[0].value,
    });
  }
}, [selectedDate]);

  const { formState: errors } = useForm({});

  const viewAllPosts = async () => {
    try {
      const response = await httpRequest().get(API_URLS.fetchScheduledPost);
      const data: MyDataType[] = response.data.data;
      setFetchedData(data);
      setShowScheduleList(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const dispatch = useDispatch();
  const { deleteLoading } = useSelector(
    ({ postFeed }: rootReducersState) => postFeed.postFeed
  );

  const getMediaPreviewUrl = (media: PostMedia) =>
    media.media_type === "video"
      ? media.media_thumbnail || media.media_original
      : media.media_thumbnail || media.media_original;

  const setPostCarouselIndex = (postId: string, nextIndex: number) => {
    setCarouselIndices((prev) => ({ ...prev, [postId]: nextIndex }));
  };

  const renderPostMedia = (post: MyDataType) => {
    if (!post.post_media?.length) return null;

    const carouselIndex = carouselIndices[post.id] ?? 0;
    const currentMedia = post.post_media[carouselIndex];
    const isVideo = currentMedia.media_type === "video";
    const mediaUrl = getMediaPreviewUrl(currentMedia);
    const hasMultiple = post.post_media.length > 1;

    return (
      <div className="scheduled-post-carousel">
        <div className="carousel-media-wrapper">
          {isVideo ? (
            <div className="video-cover">
              <Image
                src={mediaUrl}
                alt="Video thumbnail"
                className="carousel-image"
              />
              <span className="play-icon-cover">
                <i className="fa fa-play" />
              </span>
            </div>
          ) : (
            <Image
              src={mediaUrl}
              alt="Post media"
              className="carousel-image"
            />
          )}
        </div>

        {hasMultiple && (
          <>
            <span className="carousel-counter">
              {carouselIndex + 1}/{post.post_media.length}
            </span>
            {carouselIndex > 0 && (
              <button
                type="button"
                className="carousel-nav-btn prev"
                aria-label="Previous media"
                onClick={(e) => {
                  e.stopPropagation();
                  setPostCarouselIndex(post.id, carouselIndex - 1);
                }}
              >
                <ChevronLeftIcon />
              </button>
            )}
            {carouselIndex < post.post_media.length - 1 && (
              <button
                type="button"
                className="carousel-nav-btn next"
                aria-label="Next media"
                onClick={(e) => {
                  e.stopPropagation();
                  setPostCarouselIndex(post.id, carouselIndex + 1);
                }}
              >
                <ChevronRightIcon />
              </button>
            )}
          </>
        )}
      </div>
    );
  };

  const formatScheduleTime = (scheduleAt?: string) =>
    scheduleAt
      ? dayjs.utc(scheduleAt).local().format("ddd, MMM D [at] h:mm A")
      : "-";

  const handleDeletePost = async () => {
    try {
      await dispatch(deleteFeedRequest(menuPostId));

      setFetchedData((prevData) => {
        if (!prevData) {
          return null;
        }
        return prevData.filter((post) => post.id !== menuPostId);
      });
    } catch (error) {
      console.error("Error deleting post:", error);
    } finally {
      setOpenDeleteFeedModal(false);
    }
  };

  const handleEditPostUpdate = (updatedPost: MyDataType) => {
    // Update the fetchedData with the edited post
    setFetchedData((prevData) => {
      if (!prevData) return prevData;
      return prevData.map((post) =>
        post.id === updatedPost.id ? updatedPost : post
      );
    });
  };

  const onRescheduleSubmit = async () => {
    // validate date/time as before…
    const datePart = moment(selectedDate).format("YYYY-MM-DD");
    const timePart = selectedTime.value.split(" ")[1] || selectedTime.value;
    const combined = `${datePart} ${timePart}`;

    // send exactly what the backend expects
    const payload = {
      schedule_at: combined,
      timezone: userTimezone ,
    };

    const res = await httpRequest().put(
      API_URLS.reSchedulePost(reschedulePostId),
      payload
    );

    if (res.status === 200) {
      FlashMessage("Post has been rescheduled.", "success");
      // update UI
    } else {
      FlashMessage("Reschedule failed.", "error");
    }
  };

  return (
    <>
      {/* Main Schedule Modal */}
      <Modal
        title={isRescheduling ? "Reschedule post" : "Schedule post"}
        visible={open}
        className="share-modal"
        size="medium"
        onClose={() => {
          setIsRescheduling(false);
          setReschedulePostId(null);
          setSelectedDate(null);
          setSelectedTime({ label: "", value: "" });
          onClose();
        }}
      >
        <div className="date-time">
          <p className="mb3">
            Schedule your post using the current time on your device.
          </p>

          <div className="Schedule-Wrraper">
            {/* <Input
                name="date"
                type="date"
                value={
                  selectedDate ? selectedDate.toISOString().slice(0, 10) : ""
                }
                onChange={(e) => {
                  const selected = new Date(e.target.value);
                  const selectedDateOnly = new Date(
                    selected.getFullYear(),
                    selected.getMonth(),
                    selected.getDate()
                  );
                  const currentDateOnly = new Date(
                    currentDate.getFullYear(),
                    currentDate.getMonth(),
                    currentDate.getDate()
                  );
                  const maxDateOnly = new Date(
                    maxDate.getFullYear(),
                    maxDate.getMonth(),
                    maxDate.getDate()
                  );

                  if (
                    selectedDateOnly < currentDateOnly ||
                    selectedDateOnly > maxDateOnly
                  ) {
                    setDateError("Please select a date within one month from today (up to " + maxDate.toLocaleDateString() + ")");
                    setSelectedDate(null);
                    return;
                  }
                  setDateError("");
                  setSelectedDate(selected);
                }}
                min={currentDate.toISOString().slice(0, 10)}
                max={maxDate.toISOString().slice(0, 10)}
                style={{
                  cursor: 'pointer'
                }}
                onKeyDown={(e) => {
                  // Prevent manual typing to force calendar usage
                  if (e.key !== 'Tab' && e.key !== 'Enter' && e.key !== 'Escape') {
                    e.preventDefault();
                  }
                }}
              />
              {dateError && (
                <span className="error-text" style={{ color: "red" }}>
                  {dateError}
                </span>
              )} */}

            <div className="Date-wraper" ref={calWrapRef}>
              {/* <p className="scheduled-date">Date</p> */}

              {/* The visible input (kept), opens calendar on click */}
              <Input
                name="date"
                type="text"
                externalLabel={{ label: "Date" }}
                placeholder="Select Date"
                value={
                  selectedDate ? dayjs(selectedDate).format("YYYY-MM-DD") : ""
                }
                readOnly
                onClick={() => setShowCalendar((s) => !s)}
                // if you want keyboard-only user to open via Enter:
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setShowCalendar(true);
                }}
              />

              {/* Inline popover calendar */}
              {showCalendar && (
                <div className="calendar-popover">
                  <Calendar
                    className="eh-schedule-calendar"
                    value={selectedDate || new Date()}
                    onChange={(d: Date) => {
                      // Guard even though minDate/maxDate restricts UI
                      if (
                        dayjs(d).isBefore(monthStart) ||
                        dayjs(d).isAfter(monthEnd)
                      ) {
                        setDateError(
                          `Please select a date between ${monthStart.format(
                            "YYYY-MM-DD"
                          )} and ${monthEnd.format("YYYY-MM-DD")}`
                        );
                        setSelectedDate(null);
                        return;
                      }

                      setDateError("");
                      setSelectedDate(d);
                      setShowCalendar(false);
                    }}
                    next2Label={false}
                    prev2Label={false}
                    prevLabel={
                      <span className="custom-prev-label">
                        <PrevArrow />
                      </span>
                    }
                    nextLabel={
                      <span className="custom-prev-label">
                        <NextArrow />
                      </span>
                    }
                    minDate={monthStart.toDate()}
                    maxDate={monthEnd.toDate()}
                  />
                </div>
              )}

              {dateError && (
                <span className="error-text" style={{ color: "red" }}>
                  {dateError}
                </span>
              )}
            </div>

            <div className="Time-wrraper">
              {/* <p className="scheduled-time">Time</p> */}
              <SelectNew
                name="Time_status"
                value={
                  selectedTime && selectedTime.value ? selectedTime : null // this makes ReactSelect show placeholder
                }
                externalLabel={{ label: "Time" }}
                placeholder="Select Time"
                validationObj={errors}
                onChange={(option) => {
                  setSelectedTime(option);
                  setTimeError("");
                }}
                options={time.map((e) => ({
                  value: e.value,
                  label: e.label,
                }))}
                // required={true}
                rules={{
                  required: {
                    value: true,
                    message: "Please Select Time",
                  },
                }}
              />
              {timeError && (
                <span className="error-text" style={{ color: "red" }}>
                  {timeError}
                </span>
              )}
            </div>
          </div>
          <br />
          <div className="view-all-posts-link">
            <p className="span-link" onClick={viewAllPosts}>
              View all scheduled posts
            </p>
          </div>

          <div className="main-btn">
            <Button
              color="secondary"
              className="Back-button"
              onClick={() => {
                setSchedule(null);
                setSelectedDate(null);
                setSelectedTime({ label: "", value: "" });
                onClose();
                setTimeError("");
                setDateError("");
              }}
            >
              Cancel
            </Button>

            <Button
              color="primary"
              onClick={async () => {
                let hasError = false;
                if (!selectedDate) {
                  setDateError("Please select a date");
                  hasError = true;
                }
                if (!selectedTime.value) {
                  setTimeError("Please select a time");
                  hasError = true;
                }
                if (hasError) return;
                const datePart = moment(selectedDate).format("YYYY-MM-DD");
                const timePart = selectedTime.value.split(" ")[1];
                const combined = `${datePart} ${timePart}`;

                if (isRescheduling && reschedulePostId) {
                  onRescheduleSubmit();
                } else {
                  setSchedule(combined);
                }

                // cleanup
                setIsRescheduling(false);
                setReschedulePostId(null);
                setSelectedDate(null);
                setSelectedTime({ label: "", value: "" });
                onClose();
              }}
            >
              {isRescheduling ? "Reschedule" : "Schedule"}
            </Button>
          </div>
        </div>
      </Modal>

      {/* Scheduled Posts List Modal - FIXED: Removed nested modal */}
      <Modal
        visible={showScheduleList}
        onClose={() => setShowScheduleList(false)}
        className="schedule-post-modal"
        title="Scheduled Posts"
        size="large"
      >
        {fetchedData === null ? (
          <p style={{ textAlign: "center", margin: "2rem 0" }}>
            Loading scheduled posts…
          </p>
        ) : fetchedData.length === 0 ? (
          <p style={{ textAlign: "center", margin: "2rem 0" }}>
            No scheduled posts found.
          </p>
        ) : (
          <div className="all-scheduled-posts">
            {fetchedData.map((post) => {
              const hasContent = Boolean((post.content || "").trim());
              const hasMedia = post.post_media?.length > 0;

              return (
                <div key={post.id} className="scheduled-post-card">
                  <div className="scheduled-post-card__header">
                    <span className="scheduled-post-card__time">
                      Posting {formatScheduleTime(post.schedule_at)}
                    </span>
                    <button
                      type="button"
                      className="scheduled-post-card__menu"
                      aria-label="Post actions"
                      onClick={(e) => handleMenuOpen(e, post.id)}
                    >
                      <MoreHoriz />
                    </button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl) && menuPostId === post.id}
                      onClose={handleMenuClose}
                      className="schedule-menu-option-wrapper"
                    >
                      <MenuItem onClick={handlePostNow}>Post Now</MenuItem>
                      <MenuItem onClick={() => handleReschedule(post)}>
                        Reschedule
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setEditPost(post);
                          handleMenuClose();
                        }}
                      >
                        Edit Post
                      </MenuItem>
                      <MenuItem onClick={handleDelete}>Delete Post</MenuItem>
                    </Menu>
                  </div>

                  {hasContent && (
                    <div className="scheduled-post-card__content wysiwyg-data">
                      <ReadMoreLess text={post.content || ""} textLimit={180} />
                    </div>
                  )}

                  {hasMedia && (
                    <div className="scheduled-post-card__media">
                      {renderPostMedia(post)}
                    </div>
                  )}

                  {!hasContent && !hasMedia && (
                    <p className="scheduled-post-card__empty">No content added</p>
                  )}
                </div>
              );
            })}
          </div>
        )}

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <Button color="secondary" onClick={() => setShowScheduleList(false)}>
            Close
          </Button>
        </div>
      </Modal>

      {/* Edit Post Modal - FIXED: Only render when editPost exists */}
      {editPost && (
        <EditScheduledPostModal
          key={`edit-${editPost.id}`} // Add unique key to prevent issues
          post={editPost}
          open={!!editPost}
          onClose={() => setEditPost(null)}
          onUpdate={handleEditPostUpdate}
        />
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmDialog
        visible={openDeleteFeedModal}
        title="Delete post"
        onCancel={() => setOpenDeleteFeedModal(false)}
        bodyText="Do you really want to delete post?"
        onConfirm={() => {
          handleDeletePost();
          setOpenDeleteFeedModal(false);
        }}
        loading={deleteLoading}
        confirmText="Confirm"
      />
    </>
  );
}

export default ScheduleModel;
